export const siteStats = [
  { label: "已收录作品", value: "42", unit: "部", icon: "ri-film-line" },
  { label: "累计评分人数", value: "128", unit: "万", icon: "ri-user-star-line" },
  { label: "综合口碑均分", value: "8.42", unit: "分", icon: "ri-star-smile-line" },
  { label: "收录长篇影评", value: "1,860", unit: "篇", icon: "ri-article-line" },
];

export const scoreDistribution = [
  { range: "9.0 分以上", percent: 28, count: "35.8 万" },
  { range: "8.0 - 8.9 分", percent: 41, count: "52.5 万" },
  { range: "7.0 - 7.9 分", percent: 22, count: "28.2 万" },
  { range: "6.0 - 6.9 分", percent: 7, count: "9.0 万" },
  { range: "6.0 分以下", percent: 2, count: "2.5 万" },
];

export const genres = ["全部", "剧情", "悬疑", "科幻", "纪录", "爱情", "喜剧"];

export const works = [
  {
    id: "w1",
    title: "长夜列车",
    genre: "悬疑",
    tags: ["悬疑", "剧情", "群像"],
    year: 2024,
    score: 8.7,
    ratingCount: "2.4 万",
    director: "沈砚",
    duration: "118 分钟",
    oneLine: "一列驶入永夜的列车，把八个陌生人困进同一场真相。",
    synopsis:
      "暴雨夜，一列开往北方山区的列车因塌方被迫停靠。八位乘客身份各异：出走的少女、失意的记者、沉默的医生、抱着旧皮箱的老人……随着车厢里一盏灯熄灭，他们发现彼此的时间线早已在多年前交汇。影片用一个封闭空间，讨论人在绝境里如何选择记忆与坦白。",
    highlight: "剧本结构精巧，后半程反转密集，留白克制",
    poster:
      "https://readdy.ai/api/search-image?query=atmospheric%20night%20train%20interior%20with%20a%20single%20warm%20lamp%20glowing%20and%20raindrops%20on%20the%20window%2C%20deep%20shadows%2C%20cinematic%20mystery%20poster%20art%2C%20moody%20warm%20amber%20tones%2C%20artistic%20editorial%20photography%2C%20high%20detail%2C%20no%20text%2C%20no%20people&width=600&height=900&seq=fengchi-poster-01&orientation=portrait",
  },
  {
    id: "w2",
    title: "潮汐来信",
    genre: "爱情",
    tags: ["爱情", "剧情", "文艺"],
    year: 2023,
    score: 8.4,
    ratingCount: "1.9 万",
    director: "林知夏",
    duration: "106 分钟",
    oneLine: "一封迟到二十年的信，让两个海边小镇的人重新相遇。",
    synopsis:
      "邮递员苏晚每天骑着旧单车穿过海堤，为一个搬走的地址坚持投递了三年。直到某个退潮的清晨，收信人终于出现，却已是另一个人。影片以书信为线索，把小镇、潮汐与两代人的错过缝进一封封信里，节奏舒缓却不拖沓。",
    highlight: "情绪细腻，海景摄影干净，配乐克制",
    poster:
      "https://readdy.ai/api/search-image?query=handwritten%20letters%20and%20envelopes%20scattered%20on%20a%20sandy%20beach%20at%20golden%20hour%2C%20gentle%20waves%2C%20warm%20romantic%20tones%2C%20cinematic%20poster%20art%2C%20soft%20natural%20light%2C%20artistic%20editorial%20photography%2C%20high%20detail%2C%20no%20text%2C%20no%20people&width=600&height=900&seq=fengchi-poster-02&orientation=portrait",
  },
  {
    id: "w3",
    title: "山与海的回声",
    genre: "纪录",
    tags: ["纪录", "自然", "人文"],
    year: 2024,
    score: 8.9,
    ratingCount: "3.1 万",
    director: "程野",
    duration: "92 分钟",
    oneLine: "三组人，两年时间，记录一条大河的源头与入海口。",
    synopsis:
      "摄制组跟随护林员、渔民与地质学者，从海拔四千米的雪线一路拍到入海口的滩涂。全片没有旁白说教，只有风声、水声与人的呼吸。它不急着给出结论，而是把一条河的变化交给观众自己感受，是近年少见的高分自然人文纪录作品。",
    highlight: "影像震撼，同期声出色，老少皆宜",
    poster:
      "https://readdy.ai/api/search-image?query=aerial%20view%20of%20dramatic%20mountain%20ridges%20meeting%20a%20turquoise%20sea%20at%20sunrise%2C%20mist%20and%20warm%20golden%20light%2C%20cinematic%20documentary%20poster%20art%2C%20artistic%20editorial%20photography%2C%20high%20detail%2C%20no%20text%2C%20no%20people&width=600&height=900&seq=fengchi-poster-03&orientation=portrait",
  },
  {
    id: "w4",
    title: "霓虹往事",
    genre: "悬疑",
    tags: ["悬疑", "犯罪", "年代"],
    year: 2022,
    score: 7.8,
    ratingCount: "2.7 万",
    director: "何劲",
    duration: "124 分钟",
    oneLine: "老城区拆迁前夜，一桩旧案随着霓虹灯一起亮了。",
    synopsis:
      "2003 年的南方老城，即将拆迁的夜市街头，一名退休警察决定重查十五年前的悬案。影片用浓重的暖色霓虹和潮湿的巷弄营造出独特的年代质感，人物群像鲜明。中段的节奏稍显松散，但最后的真相收束有力，值得耐心看完。",
    highlight: "年代氛围突出，群像扎实，中段略缓",
    poster:
      "https://readdy.ai/api/search-image?query=rainy%20narrow%20city%20alley%20at%20night%20glowing%20with%20warm%20red%20and%20amber%20neon%20signs%2C%20wet%20reflective%20pavement%2C%20cinematic%20crime%20poster%20art%2C%20moody%20atmospheric%20lighting%2C%20high%20detail%2C%20no%20text%2C%20no%20people&width=600&height=900&seq=fengchi-poster-04&orientation=portrait",
  },
  {
    id: "w5",
    title: "星尘快递员",
    genre: "科幻",
    tags: ["科幻", "家庭", "温情"],
    year: 2023,
    score: 8.1,
    ratingCount: "2.2 万",
    director: "苏秉",
    duration: "110 分钟",
    oneLine: "在星球之间送信的人，最后送出了一封写给自己的信。",
    synopsis:
      "未来世界，人类散居在几颗殖民星上，靠一群被称为「星尘快递员」的人传递实体信件。主角阿岩接下了最后一趟跨越三星的托付，途中他逐渐明白，自己送的从来不只是信。影片把科幻设定做得很轻，重点始终落在人与牵挂上，适合全家一起观看。",
    highlight: "设定温暖，视觉明亮，亲子友好",
    poster:
      "https://readdy.ai/api/search-image?query=lone%20courier%20figure%20silhouette%20walking%20across%20a%20vast%20warm%20orange%20desert%20dune%20under%20a%20starry%20sky%20with%20a%20glowing%20horizon%2C%20cinematic%20sci-fi%20poster%20art%2C%20artistic%20editorial%20photography%2C%20high%20detail%2C%20no%20text%2C%20no%20people&width=600&height=900&seq=fengchi-poster-05&orientation=portrait",
  },
  {
    id: "w6",
    title: "夏日罐头",
    genre: "喜剧",
    tags: ["喜剧", "青春", "成长"],
    year: 2024,
    score: 7.5,
    ratingCount: "1.6 万",
    director: "周小满",
    duration: "98 分钟",
    oneLine: "四个高中生想在暑假结束前，把他们做的果酱卖出去。",
    synopsis:
      "一个关于小镇暑假的轻喜剧。四个性格迥异的高中生凑钱租下废弃小卖部，想靠自制果酱赚下学期的生活费。过程中闹出的乌龙一件接一件，最后却意外拼出了各自想去的方向。笑点自然，后三分之一略显仓促，但胜在真诚。",
    highlight: "台词幽默，节奏轻快，结局略快",
    poster:
      "https://readdy.ai/api/search-image?query=sunlit%20summer%20kitchen%20counter%20with%20glass%20jars%20of%20canned%20fruit%2C%20sheer%20curtain%20and%20playful%20warm%20sunlight%2C%20cheerful%20nostalgic%20tones%2C%20cinematic%20poster%20art%2C%20artistic%20editorial%20photography%2C%20high%20detail%2C%20no%20text%2C%20no%20people&width=600&height=900&seq=fengchi-poster-06&orientation=portrait",
  },
  {
    id: "w7",
    title: "雾都档案",
    genre: "悬疑",
    tags: ["悬疑", "年代", "推理"],
    year: 2023,
    score: 8.6,
    ratingCount: "2.9 万",
    director: "沈砚",
    duration: "132 分钟",
    oneLine: "大雾封城的三天里，档案室里少了一页纸。",
    synopsis:
      "故事发生在常年多雾的北方城市。一名档案管理员发现，三十年前一起结案的旧卷宗被人悄悄抽走了一页。为了补上这一页，他走访了当年的所有人，却发现每个人记住的版本都不一样。影片几乎全部靠对话推进，考据扎实，后劲很足，是风驰影院口碑最稳的作品之一。",
    highlight: "推理扎实，表演克制，后劲足",
    poster:
      "https://readdy.ai/api/search-image?query=foggy%20old%20stone%20alley%20with%20vintage%20street%20lamp%20glowing%20amber%20through%20thick%20mist%2C%20muted%20warm%20brown%20tones%2C%20cinematic%20mystery%20poster%20art%2C%20atmospheric%20editorial%20photography%2C%20high%20detail%2C%20no%20text%2C%20no%20people&width=600&height=900&seq=fengchi-poster-07&orientation=portrait",
  },
  {
    id: "w8",
    title: "最后一班地铁",
    genre: "剧情",
    tags: ["剧情", "都市", "现实"],
    year: 2022,
    score: 8.2,
    ratingCount: "1.8 万",
    director: "卢屿",
    duration: "104 分钟",
    oneLine: "深夜地铁上，五个陌生人的一晚，串起了整座城市。",
    synopsis:
      "末班车厢里，加班的白领、卖花的老人、刚下夜班的护士、备考的学生与一位沉默的司机，在九十分钟里各自经历了一次小小的选择。没有强烈的戏剧冲突，却把都市人的疲惫与善意拍得很准。适合一个人在深夜二刷。",
    highlight: "真实细腻，节奏舒缓，共情强",
    poster:
      "https://readdy.ai/api/search-image?query=empty%20modern%20subway%20platform%20at%20night%20with%20warm%20amber%20lights%20and%20a%20departing%20train%20in%20soft%20focus%2C%20cinematic%20urban%20drama%20poster%20art%2C%20artistic%20editorial%20photography%2C%20high%20detail%2C%20no%20text%2C%20no%20people&width=600&height=900&seq=fengchi-poster-08&orientation=portrait",
  },
];

export const ratingDimensions = [
  { label: "剧情与剧本", score: 8.6, note: "结构完整，反转有铺垫" },
  { label: "表演与角色", score: 8.8, note: "群像稳定，主角出彩" },
  { label: "摄影与美术", score: 9.0, note: "光影讲究，色调统一" },
  { label: "配乐与音效", score: 8.4, note: "克制，不抢戏" },
  { label: "节奏与剪辑", score: 8.1, note: "中段偶有拖沓" },
  { label: "台词与细节", score: 8.5, note: "生活化，有记忆点" },
];

export const featuredReviews = [
  {
    id: "r1",
    title: "《长夜列车》影评：把冷色调拍成了一束暖光",
    author: "影评人 · 陆遥",
    date: "2024 年 11 月",
    readTime: "约 6 分钟",
    score: 8.7,
    excerpt:
      "封闭空间、群像叙事、密集反转——这些标签很容易让人以为又是一部炫技的悬疑片。但《长夜列车》真正动人的，是它始终没有把人物当作解谜的工具。",
    body: [
      "影片开场用了将近十分钟铺陈车厢的质感：摇晃的吊灯、起雾的玻璃、不规律的铁轨声。这段几乎没有台词的段落，悄悄把观众的耳朵先安顿下来，也让之后每一次突如其来的沉默都显得有力。",
      "八位乘客的设定看似典型，但剧本给每个人的动机都留了一个不轻易说破的缺口。最欣赏的是它处理真相的方式——不是一次抖落所有底牌，而是让不同的人在合适的时刻各自坦白一点点，观众像拼图一样自己完成收束。",
      "缺点也有：中段的两次回忆插叙稍微打断了当下的紧张感，如果剪掉三到五分钟会更利落。不过瑕不掩瑜，它依然是近年把「封闭空间 + 群像」讲得最从容的一部。如果你喜欢慢热、后劲大的作品，这部值得一次安静的深夜观看。",
    ],
    image:
      "https://readdy.ai/api/search-image?query=close-up%20detail%20of%20a%20vintage%20film%20projector%20reel%20spinning%20with%20warm%20golden%20light%20beams%20and%20dust%20particles%2C%20cinematic%20editorial%20photography%2C%20moody%20warm%20tones%2C%20high%20detail%2C%20no%20text%2C%20no%20people&width=900&height=640&seq=fengchi-review-01&orientation=landscape",
  },
  {
    id: "r2",
    title: "《山与海的回声》观后感：一部会呼吸的纪录片",
    author: "专栏作者 · 何未",
    date: "2024 年 9 月",
    readTime: "约 5 分钟",
    score: 8.9,
    excerpt:
      "看完这部片子，我做的第一件事是关掉手机里的背景音乐，安静坐了五分钟。它没有告诉你任何道理，却让你想起自己多久没有认真听过风声。",
    body: [
      "三组人物、两年拍摄、一条河从雪山到海口。《山与海的回声》几乎放弃了纪录片常见的旁白引导，把解释权完全交给画面和同期声。护林员在雪线上啃冷馒头的咀嚼声，渔民收网时绳索的摩擦声，都被完整地保留了下来。",
      "很多人担心没有旁白会看不懂，恰恰相反，画面本身足够清楚。它用季节的更替来分段，用水的形态来串场，观众不会迷路，只会慢慢地被带进一种更慢的节奏里。",
      "这是一部适合带父母一起看、也适合独自安静看的作品。它不会给你结论，只会给你一点耐心。如果你最近有点疲惫，我会把它列进「优先观看」的名单。",
    ],
    image:
      "https://readdy.ai/api/search-image?query=aerial%20seascape%20of%20warm%20golden%20sunrise%20over%20calm%20water%20with%20soft%20mist%20and%20distant%20mountain%20silhouettes%2C%20cinematic%20editorial%20photography%2C%20serene%20warm%20tones%2C%20high%20detail%2C%20no%20text%2C%20no%20people&width=900&height=640&seq=fengchi-review-02&orientation=landscape",
  },
  {
    id: "r3",
    title: "《雾都档案》深度解析：谁在雾里说了谎",
    author: "内容编辑 · 苏澜",
    date: "2023 年 12 月",
    readTime: "约 7 分钟",
    score: 8.6,
    excerpt:
      "明明是同一起旧案，为什么每个人记住的版本都不一样？这篇解析从那一页被抽走的档案说起，帮你把散落在线索里的细节重新排好。",
    body: [
      "《雾都档案》最聪明的地方，是它把「记忆不可靠」这个主题，藏进了一个看起来非常朴素的调查过程里。档案管理员没有超能力，他只有一辆旧自行车和一本笔记本，走访、记录、比对，然后一次次推翻自己。",
      "全片几乎靠对话推进，但信息密度并不低。注意看每次访谈时背景里出现的物件，它们往往比台词更早透露真相：一盆枯掉的花、墙上换过的相框、桌上没喝完的茶。这些细节值得二刷时留意。",
      "如果说《长夜列车》胜在结构，《雾都档案》就更胜在克制。它不急着让观众恨谁，也不急着让观众原谅谁，只是把雾一层层吹开。看完之后你会发现，真正被收走的那一页，其实一直都在每个人心里。",
    ],
    image:
      "https://readdy.ai/api/search-image?query=artistic%20abstract%20composition%20of%20layered%20fog%20and%20warm%20amber%20street%20light%20reflections%20on%20wet%20stone%2C%20cinematic%20editorial%20photography%2C%20moody%20atmospheric%20tones%2C%20high%20detail%2C%20no%20text%2C%20no%20people&width=900&height=640&seq=fengchi-review-03&orientation=landscape",
  },
];

export const audienceImpressions = [
  {
    id: "a1",
    name: "夜行的猫",
    initial: "夜",
    score: 9.0,
    mood: "好评",
    work: "长夜列车",
    text: "本来只是随便点开的，结果一口气看完。最喜欢结尾那盏灯亮起来的一瞬间，前面所有铺垫都有了答案。看完躺在床上想了很久。",
    likes: 326,
  },
  {
    id: "a2",
    name: "海边的阿昼",
    initial: "昼",
    score: 9.2,
    mood: "好评",
    work: "山与海的回声",
    text: "带爸妈一起看的，全程没人说话。画面太干净了，海和山都拍得特别舒服。我爸看完说想去看看那条河，已经在查路线了。",
    likes: 512,
  },
  {
    id: "a3",
    name: "半糖不加冰",
    initial: "半",
    score: 7.0,
    mood: "中评",
    work: "夏日罐头",
    text: "前半段挺好笑的，几个学生的互动很自然。就是后面收得有点快，感觉还差一场戏。作为周末放松的片子完全够用。",
    likes: 148,
  },
  {
    id: "a4",
    name: "雾里看灯",
    initial: "雾",
    score: 8.8,
    mood: "好评",
    work: "雾都档案",
    text: "细节控狂喜。第二遍看才发现背景里的道具几乎每一件都有意义。对话戏拍得一点都不闷，反而越看越紧张。",
    likes: 407,
  },
  {
    id: "a5",
    name: "凌晨三点的电台",
    initial: "凌",
    score: 8.3,
    mood: "好评",
    work: "最后一班地铁",
    text: "很适合深夜看。没有什么大起大落，但每个角色都像身边的人。卖花的老人那段我直接看哭了，太真实了。",
    likes: 289,
  },
  {
    id: "a6",
    name: "阿岩的背包",
    initial: "岩",
    score: 8.1,
    mood: "好评",
    work: "星尘快递员",
    text: "设定很轻，不烧脑，特别适合跟小朋友一起看。画面暖暖的，结尾那封信写得很好。缺点是世界观可以再展开一点。",
    likes: 233,
  },
  {
    id: "a7",
    name: "旧皮的抽屉",
    initial: "旧",
    score: 7.6,
    mood: "中评",
    work: "霓虹往事",
    text: "年代感做得真好，那种湿漉漉的老街氛围一下就把我拉回去了。就是中间拖了一点，如果节奏再紧一些会更棒。",
    likes: 176,
  },
  {
    id: "a8",
    name: "退潮以后",
    initial: "退",
    score: 8.5,
    mood: "好评",
    work: "潮汐来信",
    text: "画面美到随便截一帧都能当壁纸。信和潮汐这个意象用得很巧，两个人错过的部分不刻意，看完心里软软的。",
    likes: 361,
  },
];

export const moodFilters = ["全部", "好评", "中评"];

export const selectionScenarios = [
  {
    key: "solo",
    label: "独自深夜",
    icon: "ri-moon-clear-line",
    desc: "想要一部能安静看完、后劲大的作品？",
    picks: [
      { title: "长夜列车", reason: "慢热后劲强，深夜观看代入感最佳", score: 8.7 },
      { title: "雾都档案", reason: "靠对话推进，安静却有张力", score: 8.6 },
      { title: "最后一班地铁", reason: "都市孤独感，一个人看刚刚好", score: 8.2 },
    ],
  },
  {
    key: "date",
    label: "情侣约会",
    icon: "ri-heart-3-line",
    desc: "想要一部好看又好聊、看完有话题的作品？",
    picks: [
      { title: "潮汐来信", reason: "画面唯美，情绪细腻，适合两个人", score: 8.4 },
      { title: "夏日罐头", reason: "轻松好笑，气氛不压抑", score: 7.5 },
      { title: "星尘快递员", reason: "温情治愈，看完心里暖暖的", score: 8.1 },
    ],
  },
  {
    key: "family",
    label: "家庭周末",
    icon: "ri-home-heart-line",
    desc: "想要一部老少皆宜、不用担心尴尬镜头的作品？",
    picks: [
      { title: "山与海的回声", reason: "自然人文纪录，全家都能看进去", score: 8.9 },
      { title: "星尘快递员", reason: "亲子友好，设定轻，画面明亮", score: 8.1 },
      { title: "夏日罐头", reason: "青春成长，笑点温和不冒犯", score: 7.5 },
    ],
  },
  {
    key: "friends",
    label: "朋友聚会",
    icon: "ri-group-line",
    desc: "想要一部适合一起看、看完能讨论半天？",
    picks: [
      { title: "霓虹往事", reason: "悬念多，适合边看边猜", score: 7.8 },
      { title: "长夜列车", reason: "反转密集，散场后话题不断", score: 8.7 },
      { title: "夏日罐头", reason: "轻松解压，笑声有共鸣", score: 7.5 },
    ],
  },
];

export const faqs = [
  {
    q: "风驰影院的作品到底好看吗？",
    a: "从目前收录的口碑数据看，风驰影院的作品整体评价偏中上：综合均分约 8.42 分，9.0 分以上的作品占比约 28%。其中悬疑与纪录题材的口碑最稳，喜剧类相对亲民但争议稍多。如果只看一部，建议从口碑最高的《山与海的回声》或《长夜列车》入手。",
  },
  {
    q: "这里的评分和口碑是怎么来的？",
    a: "页面中的评分是按题材、表演、摄影、配乐、节奏、台词六个维度汇总的观众印象与观后感后得出的参考分数，属于综合整理的结果，并非官方数据。它更适合用来快速判断一部作品的整体方向，而不是替代你自己的观感。",
  },
  {
    q: "第一次看风驰影院的作品，推荐什么顺序？",
    a: "如果是悬疑爱好者，可以按《长夜列车》→《雾都档案》的顺序，先看结构再品细节；如果偏好轻松一些的，可以先看《山与海的回声》和《星尘快递员》；如果想先感受影像风格，《潮汐来信》是不错的入门选择。",
  },
  {
    q: "这些作品适合和孩子一起看吗？",
    a: "《山与海的回声》《星尘快递员》《夏日罐头》整体温和，适合家庭共同观看；《长夜列车》《雾都档案》《霓虹往事》涉及悬疑与犯罪议题，建议根据孩子的年龄酌情选择。这里只提供一般性参考，具体分级请以实际放映信息为准。",
  },
  {
    q: "中评和差评主要集中在哪些方面？",
    a: "从整理的观后感看，中评大多集中在节奏问题——部分作品中段略显拖沓，或结尾收束过快。此外，观众对喜剧类作品的期待差异较大，因此评分分布更分散。这些反馈都被保留在本页的观众观后感中，方便你综合判断。",
  },
  {
    q: "口碑数据会更新吗？",
    a: "会的。本页会随着新作品上线和观众评价的累积而调整分数与推荐顺序。你可以把这里当作一个持续维护的参考入口，在决定值不值得看之前，先快速了解当下的整体口碑。",
  },
];

export const heroTags = ["口碑总览", "作品评分榜", "深度影评", "观众观后感"];